import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard, FileText, FolderGit2,
  User, Users, Building2, Layers, HelpCircle as QIcon, UserPlus, UserCheck
} from 'lucide-react';
import './Sidebar.css';

const Sidebar = () => {
  const { isSuperAdmin } = useAuth();

  const employeeNavItems = [
    { label: 'Dashboard', path: '/dashboard', icon: LayoutDashboard },
    { label: 'Company Policies', path: '/company-policies', icon: FileText },
    { label: 'My Projects', path: '/my-projects', icon: FolderGit2 },
    { label: 'My Profile', path: '/profile', icon: User },
  ];

  const adminNavItems = [
    { label: 'Admin Overview', path: '/admin', icon: LayoutDashboard },
    { label: 'HR Management', path: '/admin/hr', icon: UserCheck },
    { label: 'Employee Roster', path: '/admin/employees', icon: Users },
    { label: 'Departments', path: '/admin/departments', icon: Building2 },
    { label: 'Project Portfolio', path: '/admin/projects', icon: Layers },
    { label: 'Policy Documents', path: '/admin/policies', icon: FileText },
    { label: 'Question Bank', path: '/admin/questions', icon: QIcon },
    { label: 'Project Matrix', path: '/admin/assignments', icon: UserPlus },
  ];

  const navItems = isSuperAdmin ? adminNavItems : employeeNavItems;

  return (
    <aside className="sidebar-container">
      <div className="sidebar-header-label">
        {isSuperAdmin ? 'SUPER ADMIN WORKSPACE' : 'EMPLOYEE PORTAL'}
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/admin' || item.path === '/dashboard'}
              className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>


    </aside>
  );
};

export default Sidebar;
